/**
 * Cart Redirect & Auto-open Functionality
 * Handles redirecting /cart to /collections/ and opening the cart drawer
 */

// Check if we're redirected - add diagnostic function to the page for debugging
function addCartDebugger() {
    // Create a debug function in the global scope that can be called from console
    window.debugCartDrawer = function () {
        const cartDrawer = document.querySelector('m-cart-drawer');
        if (!cartDrawer) {
            return;
        }

        // Check inner element
        const inner = cartDrawer.querySelector('.m-cart-drawer__inner');

        // Check cart items
        const items = cartDrawer.querySelectorAll('[data-minimog-cart-items] .m-cart-item');

        // Check if any other elements have the cart drawer open class
        const otherDrawers = document.querySelectorAll('.m-cart-drawer--active:not(m-cart-drawer)');
    };

    // Run debug automatically on load
    setTimeout(window.debugCartDrawer, 2000);
}

// Create a consistent cart drawer opener function that will be available globally
window.openCartDrawer = function () {
    // Find the cart drawer element
    const cartDrawer = document.querySelector('m-cart-drawer');
    if (!cartDrawer) {
        return false;
    }

    // Check if drawer is already open to avoid flickering
    if (cartDrawer.classList.contains('m-cart-drawer--active')) {
        // Make sure the styles are applied correctly
        cartDrawer.style.setProperty('--m-bg-opacity', '0.5');
        const cartDrawerInner = cartDrawer.querySelector('.m-cart-drawer__inner');
        if (cartDrawerInner) {
            cartDrawerInner.style.setProperty('--translate-x', '0');
        }

        // Make sure body scroll is prevented
        document.documentElement.classList.add('prevent-scroll');

        return true;
    }

    try {
        // Method 1: Try using the native open method first
        if (typeof cartDrawer.open === 'function') {
            cartDrawer.open();
            return true;
        }

        // Method 2: Directly manipulate the DOM like the theme does

        // Add active class to the drawer
        cartDrawer.classList.add('m-cart-drawer--active');

        // Find the inner drawer and set its transform
        const cartDrawerInner = cartDrawer.querySelector('.m-cart-drawer__inner');
        if (cartDrawerInner) {
            // Ensure we run this in the next animation frame for smooth transition
            window.requestAnimationFrame(() => {
                // Set the overlay opacity
                cartDrawer.style.setProperty('--m-bg-opacity', '0.5');
                // Slide in the drawer
                cartDrawerInner.style.setProperty('--translate-x', '0');
            });
        }

        // Prevent body scrolling
        document.documentElement.classList.add('prevent-scroll');

        // Method 3: Try using MinimogEvents as a fallback
        if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
            window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.openCartDrawer);
        }

        // Method 4: Try dispatching custom events
        try {
            document.dispatchEvent(new CustomEvent('cart:open'));
            document.dispatchEvent(new CustomEvent('cart:opened'));
        } catch (e) {
            // Silent error handling
        }

        return true;
    } catch (e) {
        // Last resort: click the cart icon
        const cartIcon = document.querySelector('.m-cart-icon-bubble');
        if (cartIcon) {
            cartIcon.click();
            return true;
        }

        return false;
    }
};

// Wait for cart drawer component to be defined and MinimogEvents to be available
function waitForDependencies(callback, maxAttempts = 10, interval = 300) {
    let attempts = 0;

    const checkDependencies = function () {
        // Check if cart drawer component exists and MinimogEvents is loaded
        const cartDrawerExists = customElements.get('m-cart-drawer') !== undefined;
        const eventsExist = window.MinimogEvents !== undefined && window.MinimogTheme !== undefined;

        attempts++;

        if (cartDrawerExists && eventsExist) {
            callback();
        } else if (attempts < maxAttempts) {
            setTimeout(checkDependencies, interval);
        } else {
            // Try callback anyway as last resort
            callback();
        }
    };

    checkDependencies();
}

// Set up mutation observer to detect when cart-drawer is added to the DOM
function setupCartDrawerObserver() {
    // Function to check if an element matches our target
    const isCartDrawer = node => node.tagName && node.tagName.toLowerCase() === 'm-cart-drawer';

    // Callback executed when mutations are observed
    const mutationCallback = function (mutationsList, observer) {
        for (const mutation of mutationsList) {
            // Check for nodes added to the DOM
            if (mutation.type === 'childList') {
                // Check added nodes for cart drawer
                for (const node of mutation.addedNodes) {
                    if (isCartDrawer(node)) {
                        // Give it a moment to initialize
                        setTimeout(function () {
                            if (sessionStorage.getItem('redirected_from_cart') === 'true') {
                                sessionStorage.removeItem('redirected_from_cart');
                                window.openCartDrawer();
                            }
                        }, 100);

                        // Once we've found it, no need to observe anymore
                        observer.disconnect();
                        return;
                    }

                    // If it's another element, check its children recursively
                    if (node.childNodes && node.childNodes.length) {
                        const cartDrawer = node.querySelector('m-cart-drawer');
                        if (cartDrawer) {
                            // Give it a moment to initialize
                            setTimeout(function () {
                                if (sessionStorage.getItem('redirected_from_cart') === 'true') {
                                    sessionStorage.removeItem('redirected_from_cart');
                                    window.openCartDrawer();
                                }
                            }, 100);

                            // Once we've found it, no need to observe anymore
                            observer.disconnect();
                            return;
                        }
                    }
                }
            }
        }
    };

    // Check if cart drawer already exists on the page
    const existingCartDrawer = document.querySelector('m-cart-drawer');
    if (existingCartDrawer) {
        // Give it a moment to initialize if needed
        setTimeout(function () {
            if (sessionStorage.getItem('redirected_from_cart') === 'true') {
                sessionStorage.removeItem('redirected_from_cart');
                window.openCartDrawer();
            }
        }, 100);
        return;
    }

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(mutationCallback);

    // Start observing the document with the configured parameters
    observer.observe(document.documentElement, { childList: true, subtree: true });

    // Also set a timeout to stop observing after a while to prevent memory leaks
    setTimeout(function () {
        if (observer) {
            observer.disconnect();
        }
    }, 10000); // Stop after 10 seconds
}

// Main cart redirect functionality - executed immediately
(function () {
    // Check if we need to redirect from /cart - using regex to match /cart, /cart/, /cart?*, etc.
    if (/^\/cart(\?.*)?(\/.*)?\/?$/.test(window.location.pathname)) {
        // Store flags in sessionStorage indicating we're coming from /cart
        sessionStorage.setItem('redirected_from_cart', 'true');
        // Redirect to collection page with a special hash that triggers cart opening
        window.location.href = '/collections/#opencart';
    }

    // Check if we have the special hash that should trigger cart opening
    if (window.location.hash === '#opencart') {
        sessionStorage.setItem('redirected_from_cart', 'true');
        // Remove the hash to avoid reopening on page refresh
        history.replaceState(null, null, window.location.pathname + window.location.search);
    }

    // Add cart debugger in all cases
    addCartDebugger();
})();

// Track whether we've already opened the cart drawer
let cartDrawerOpened = false;

// Document ready handler for normal page loads
document.addEventListener('DOMContentLoaded', function () {
    // Check if we need to open the cart drawer
    const shouldOpenCart = sessionStorage.getItem('redirected_from_cart') === 'true' ||
        window.location.hash === '#opencart';

    if (shouldOpenCart && !cartDrawerOpened) {
        // Clear the flag to prevent reopening on refresh
        sessionStorage.removeItem('redirected_from_cart');

        // If hash is present, remove it
        if (window.location.hash === '#opencart') {
            history.replaceState(null, null, window.location.pathname + window.location.search);
        }

        // Mark as opened to prevent multiple attempts
        cartDrawerOpened = true;

        // Strategic approach: wait for a short time to ensure all necessary scripts are loaded
        setTimeout(function () {
            window.openCartDrawer();

            // Run the debugger after a delay to check the state
            setTimeout(window.debugCartDrawer, 1000);
        }, 500);
    }
});

// Window load event is a good time to attempt cart open if not already done
window.addEventListener('load', function () {
    // Only try if we should open the cart but haven't successfully done so yet
    const shouldOpenCart = sessionStorage.getItem('redirected_from_cart') === 'true' ||
        window.location.hash === '#opencart';

    if (shouldOpenCart && !cartDrawerOpened) {
        sessionStorage.removeItem('redirected_from_cart');
        cartDrawerOpened = true;
        window.openCartDrawer();
    }
}); 